// Centralização dos endpoints da API
// n8n (legado — migração gradual para o backend Node)
const BASE_URL = "https://automation.floripasoftware.com.br/webhook";

// Backend Node.js 4.0 — em dev o Next faz proxy de /api → localhost:4000
const API_BASE = process.env.NEXT_PUBLIC_API_URL || "/api";

export const ENDPOINTS = {
  // Usuários
  USUARIO_LIST: `${BASE_URL}/advserv_usuario_list`,
  USUARIO_DELETE: `${BASE_URL}/advserv_usuario_delete`,
  USUARIO_CREATE: `${BASE_URL}/advserv_usuario_create`,
  USUARIO_UPDATE: `${BASE_URL}/advserv_usuario_update`,
  USUARIO_LIST_EXECUTOR: `${BASE_URL}/advserv_usuario_list_executor`,
  USUARIO_PERMISSOES: `${BASE_URL}/advserv_usuario_permissoes`,

  // Departamentos
  DEPARTAMENTO_LIST: `${BASE_URL}/advserv_departamento_list`,
  DEPARTAMENTO_DELETE: `${BASE_URL}/advserv_departamento_delete`,
  DEPARTAMENTO_CREATE: `${BASE_URL}/advserv_departamento_create`,
  DEPARTAMENTO_UPDATE: `${BASE_URL}/advserv_departamento_update`,

  // Ordem de Serviço
  OS_READ: `${BASE_URL}/advserv_os_read`,
  OS_LIST: `${BASE_URL}/advserv_os_list`,
  OS_DELETE: `${BASE_URL}/advserv_os_delete`,
  OS_DISTRIBUIR: `${BASE_URL}/advserv_os_distribuir`,
  OS_ACEITAR: `${BASE_URL}/advserv_os_aceitar`,
  OS_GRAVAR: `${BASE_URL}/advserv_os_gravar`,
  OS_FINALIZAR: `${BASE_URL}/advserv_os_finalizar`,
  OS_CANCELAR: `${BASE_URL}/advserv_os_cancelar`,
  OS_ATRIBUIR: `${BASE_URL}/advserv_os_atribuir`,

  // Dashboard
  DASHBOARD_DEPARTAMENTOS: `${BASE_URL}/advserv_dashboard_departamentos`,
  DASHBOARD_CONTADORES: `${BASE_URL}/advserv_dashboard_contadores`,

  // Login
  LOGIN: `${BASE_URL}/advserv_login`,

  // QRCode
  QRCODE_GENERATE: `${BASE_URL}/advserv_qrcode_generate`,

  // Outros (exemplo dinâmico)
  SAVE_OS: (unidade: string) => `${BASE_URL}/saveos_${(unidade || '').toLowerCase()}`,

  // Preventivas — backend Node (não usa n8n)
  PREVENTIVAS_TIPOS: `${API_BASE}/preventivas/tipos`,
  PREVENTIVAS_ATIVOS: `${API_BASE}/preventivas/ativos`,
  PREVENTIVAS_PLANOS: `${API_BASE}/preventivas/planos`,
  PREVENTIVAS_AGENDA: `${API_BASE}/preventivas/agenda`,
  PREVENTIVAS_GERAR_OS: `${API_BASE}/preventivas/gerar-os`,
  PREVENTIVAS_GERAR_OS_ATRASADAS: `${API_BASE}/preventivas/gerar-os-atrasadas`,
}; 